<template>
    <div class="default-instructions">
        <span class="default-instructions-title" v-text="$ml.get('textInstructionPayment')" tabindex="0" />

        <span class="default-instructions-blue" v-text="$ml.get('textInstructionPayment2')" tabindex="0" />

        <div>
            <div class="d-inline-block" style="margin: 5px 5px 0px 0px;" :key="key" v-for="(item, key) in items">
                <img style="width: 50px; height: 50px;" :src="item" />
            </div>
            <a class="d-inline-block" style="margin-top: 5px; cursor: pointer;" href="#cieloLinkTarget">
                <img style="width: 50px; height: 50px;" :src="ellipseImg" alt="" tabindex="-1" />
                <img style="position: relative; right: 29px;" :src="plusImg" alt="" tabindex="-1" />
            </a>
        </div>
    </div>
</template>

<script>
import bbImg from '@/assets/img/bb.jpg';
import bradescoImg from '@/assets/img/bradesco.jpg';
import ellipseImg from '@/assets/img/Ellipse.jpg';
import mercadoPagoImg from '@/assets/img/mercadoPago.jpg';
import picpayImg from '@/assets/img/picpay.jpg';
import plusImg from '@/assets/img/plus.jpg';

export default {
  computed: {
    items() {
      return [
        bbImg,
        bradescoImg,
        mercadoPagoImg,
        picpayImg
      ];
    },
    ellipseImg() { return ellipseImg; },
    plusImg() { return plusImg; }
  }
};
</script>

<style scoped>
.default-instructions {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
}

.default-instructions-blue {
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  color: #5C6A7B;
}

.default-instructions-title {
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  color: #2F363E;
}
</style>